// ============================================================================
// CANCUN100 — pdfFonts.js
// Registro de fuentes DM Sans y Space Grotesk para @react-pdf/renderer
// ============================================================================
// Las fuentes TTF deben estar en: src/pdf/fonts/
//   - DMSans-Regular.ttf       (400)
//   - DMSans-Medium.ttf        (500)
//   - DMSans-Bold.ttf          (700)
//   - SpaceGrotesk-Bold.ttf    (700)
//   - SpaceGrotesk-Regular.ttf (400, por si se necesita)
//
// Este archivo se importa UNA SOLA VEZ al inicio. El registro de fuentes
// es global y persiste mientras dure la sesión del navegador.
// ============================================================================

import { Font } from '@react-pdf/renderer';

// Importamos los archivos TTF — webpack los procesa y devuelve el path
import DMSansRegular from './fonts/DMSans-Regular.ttf';
import DMSansMedium  from './fonts/DMSans-Medium.ttf';
import DMSansBold    from './fonts/DMSans-Bold.ttf';
import SpaceGroteskBold    from './fonts/SpaceGrotesk-Bold.ttf';
import SpaceGroteskRegular from './fonts/SpaceGrotesk-Regular.ttf';

// Bandera para evitar registrar dos veces si se importa este módulo en varios PDFs
let registered = false;

export const registerFonts = () => {
  if (registered) return;

  Font.register({
    family: 'DM Sans',
    fonts: [
      { src: DMSansRegular, fontWeight: 400 },
      { src: DMSansMedium,  fontWeight: 500 },
      { src: DMSansBold,    fontWeight: 700 },
    ],
  });

  Font.register({
    family: 'Space Grotesk',
    fonts: [
      { src: SpaceGroteskRegular, fontWeight: 400 },
      { src: SpaceGroteskBold,    fontWeight: 700 },
    ],
  });

  // Desactivar hyphenation automática (que parte palabras feo en español)
  Font.registerHyphenationCallback((word) => [word]);

  registered = true;
};

// Auto-registrar al importar (para conveniencia)
registerFonts();
